document.addEventListener('DOMContentLoaded', function() {
    function calculatePercentage() {
        const priceElement = document.querySelector('.product__info-wrapper .price-item--last > span');
        const gstAmountElements = document.querySelectorAll('.gst-amount');
 
        if (priceElement && gstAmountElements.length > 0) {
            const priceString = priceElement.textContent.replace(/[^0-9.]/g, ''); 
            const priceValue = parseFloat(priceString);
            if (!isNaN(priceValue)) {
                const percentageValue = priceValue * 0.18;
                gstAmountElements.forEach(element => {
                    element.textContent = `₹${percentageValue.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                });
              
            } else {
                console.error('Unable to parse the price value.');
            }
        } else {
            console.error('Price element not found or no elements with class gst-amount.');
        }
    }
 
    function debounce(func, delay) {
        let debounceTimer;
        return function() {
            const context = this;
            const args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func.apply(context, args), delay);
        };
    }
 
    const debouncedCalculatePercentage = debounce(calculatePercentage, 300);
 
    function observePriceChanges() {
        const priceElement = document.querySelector('.product__info-wrapper .price-item--last > span');
        if (!priceElement) {
            console.error('Price element not found.');
            return;
        }
 
        const observer = new MutationObserver(() => {
            debouncedCalculatePercentage();
        });
 
        observer.observe(priceElement, {
            childList: true,
            subtree: true,
            characterData: true
        });
 
        calculatePercentage();
    }
 
    function handleSwatchClick() {
        setTimeout(() => {
            observePriceChanges(); 
        }, 2000); // Wait for 2 seconds after swatch click
    }
 
    function observeSwatchChanges() {
        const swatchContainers = document.querySelectorAll('.color_swatch__container, .variant__option');
        if (!swatchContainers || swatchContainers.length === 0) {
            console.error('Swatch containers not found.');
            return;
        }
 
        swatchContainers.forEach(container => {
            container.addEventListener('click', handleSwatchClick);
        });
    }
 
    window.addEventListener('load', () => {
        observePriceChanges();
        observeSwatchChanges(); 
    });
});


// show popup script
document.addEventListener('DOMContentLoaded', function() {
        const viewContent = document.querySelector('.view-content');
        const popupContainer = document.querySelector('.gst-popup-container');
        const closeButton = document.querySelector('.button-box');
        const overlay1 = document.createElement('div');
        overlay1.classList.add('overlay1');
        document.body.appendChild(overlay1);

        viewContent?.addEventListener('click', function() {
            popupContainer.classList.add('show-popup');
            overlay1.style.display = 'block';
        });

        closeButton?.addEventListener('click', function() {
            popupContainer.classList.remove('show-popup');
            overlay1.style.display = 'none';
        });

        overlay1?.addEventListener('click', function() {
            popupContainer.classList.remove('show-popup');
            overlay1.style.display = 'none';
        });
    });



